import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BedDouble } from "lucide-react";
import { getRoomSession, clearRoomSession, touchRoomSession } from "../lib/roomSession";
import { unlockRoom } from "../lib/api";

const RECHECK_MS = 10 * 60 * 1000;

// Round "my room" shortcut for the brown bars: visible only after the guest
// unlocked a room with the PIN on this phone. Hidden while already in that room.
// The saved PIN is re-validated server-side (at most every 10 min): when the
// TTLock code expires at checkout the button disappears by itself.
export function RoomShortcut({ size = "h-10 w-10", icon = "h-5 w-5" }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [session, setSession] = useState(getRoomSession);

  useEffect(() => {
    const refresh = () => setSession(getRoomSession());
    window.addEventListener("room-session-change", refresh);
    window.addEventListener("storage", refresh);
    return () => { window.removeEventListener("room-session-change", refresh); window.removeEventListener("storage", refresh); };
  }, []);

  useEffect(() => {
    if (!session || Date.now() - (session.checked || 0) < RECHECK_MS) return;
    unlockRoom(session.slug, session.pin)
      .then(() => touchRoomSession())
      .catch((e) => { if (e?.response?.status === 401 || e?.response?.status === 404) clearRoomSession(); });
  }, [session]);

  if (!session || pathname.toLowerCase() === `/room/${session.slug}`) return null;
  const label = session.name ? `Camera ${session.name}` : "La mia camera";
  return (
    <button
      type="button"
      onClick={() => navigate(`/room/${session.slug}`)}
      className={`${size} rounded-full bg-white/10 ring-1 ring-[#f7ebdf]/35 text-[#f7ebdf] flex items-center justify-center hover:bg-white/20 active:scale-95 transition-[background-color,transform] shrink-0`}
      data-testid="header-room-btn"
      aria-label={label}
      title={label}
    >
      <BedDouble className={icon} />
    </button>
  );
}
